import { Injectable } from '@angular/core';
import { setOptions, MbscOptions  } from '@mobiscroll/angular';
import { localeDe } from '@mobiscroll/angular';

@Injectable({
  providedIn: 'root',
})
export class ThemeService {
   private themeOptions: Partial<MbscOptions> = {
    locale: localeDe,
    theme: 'ios',
    themeVariant: 'light', 
  };

  isDarkMode: boolean = false;

  constructor() {
    const savedThemeOptions = localStorage.getItem('themeOptions');
    if (savedThemeOptions) {
      this.themeOptions = JSON.parse(savedThemeOptions);
      if(this.themeOptions.themeVariant === 'dark'){
        this.isDarkMode = true;
      }
    }
    this.applyThemeOptions();
    this.toggleDarkBody(this.isDarkMode)
  }

  applyThemeOptions() {
    setOptions(this.themeOptions);
  }

  toggleTheme() {
    this.isDarkMode = !this.isDarkMode;
    this.toggleDarkBody(this.isDarkMode)
    this.themeOptions.themeVariant = this.themeOptions.themeVariant === 'light' ? 'dark' : 'light';
    this.applyThemeOptions();
    this.saveThemeToLocalStorage();
  }

  setThemeOptions(options: any) {
    this.themeOptions = { ...this.themeOptions, ...options };
    this.applyThemeOptions();
    this.saveThemeToLocalStorage();
  }

  private saveThemeToLocalStorage() {
    localStorage.setItem('themeOptions', JSON.stringify(this.themeOptions));
  }

  toggleThemeType() {
    if (this.themeOptions.theme === 'ios') {
      this.themeOptions.theme = 'material';
    } else if (this.themeOptions.theme === 'material') {
      this.themeOptions.theme = 'windows';
    } else {
      this.themeOptions.theme = 'ios';
    }
    this.applyThemeOptions();
    this.saveThemeToLocalStorage();
  }

  toggleDarkBody(isDarkMode: boolean) {
    const body = document.body;
    if(!isDarkMode){
      body.classList.remove('darkmode');
    }else{
      body.classList.add('darkmode');
    }
  }
}